import React, { useState, useEffect } from 'react';
import { Sector } from 'recharts';
import capitalizeFirstLetter from '../../../../Components/Utils/Funcs';
import UseGetDashBoardWithParams from '../../../../Components/Hooks/useDashboardDataParams';
import colorCodes from '../../../../Components/Utils/ColorCode';
import PieCharts from '../../../../Components/Charts/PieChart';

function InspectionAllocation() {
  const [params, setParams] = useState({
    period: 'monthly'
  });
  const [selectedPeriod, setSelectedPeriod] = useState('monthly');
  const [chartData, setChartData] = useState([]);

  const { data, loading } = UseGetDashBoardWithParams(`/dashboard/inspection-allocations`, params);

  const periods = [
    { value: 'monthly', option: 'Monthly' },
    { value: 'quarterly', option: 'Quarterly' },
    { value: 'halfyearly', option: 'Half Yearly' },
    { value: 'yearly', option: 'Yearly' },
  ];

  useEffect(() => {
    if (data && data.length > 0) {
      // Transform API data into chart format
      const transformedData = data.map(item => ({
        name: item.inspector,
        value: item.total_assigned,
        ...item // Include all original properties
      }));
      setChartData(transformedData);
    } else {
      setChartData([]);
    }
  }, [data]);

  function handlePeriodChange(e) {
    const newPeriod = e.target.value;
    setSelectedPeriod(newPeriod);
    setParams({ period: newPeriod });
  }

  const totalInspections = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="col-span-2 bg-gradient-to-r from-white to-gray-50 md:h-[46vh] w-full p-4 rounded-2xl shadow-lg flex flex-col justify-between">
      <div className="flex justify-between items-center mb-1">
        <p className="text-gray-700 text-sm font-bold mb-1">Inspection Allocation</p>
        <div className="flex items-center">
          <select
            value={selectedPeriod}
            onChange={handlePeriodChange}
            className="border rounded-md p-1 text-xs text-[#ACACAC] font-normal"
          >
            {periods.map(period => (
              <option key={period.value} value={period.value}>
                {period.option}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="border-t border-[1px] border-slate-200/60 border-solid w-full"></div>

      {loading ? (
        <div className="md:flex justify-center items-center h-full">
          <div className="animate-pulse space-y-4 w-full">
            <div className="h-4 bg-slate-200 rounded"></div>
            <div className="h-4 bg-slate-200 rounded"></div>
            <div className="h-4 bg-slate-200 rounded"></div>
            <div className="h-4 bg-slate-200 rounded"></div>
          </div>
        </div>
      ) : (
        <div className="w-full md:flex md:h-[89%]">
          {chartData.length > 0 ? (
            <>
              <div className="flex justify-center items-center md:w-[20%]">
                <PieCharts
                  data={chartData}
                  label={true}
                  labelValue={totalInspections}
                  COLORS={colorCodes.slice(0, chartData.length)}
                  height={140}
                />
              </div>
              <div className="overflow-y-auto md:w-[80%]">
                <div className="w-full font-medium sticky top-0 bg-white shadow-sm flex justify-start gap-4 pt-2 text-xs 2xl:text-sm">
                  <p className="w-[35%]">Inspector</p>
                  <p className="w-[15%]">Assigned</p>
                  <p className="w-[15%]">Upcoming</p>
                  <p className="w-[15%]">Over Due</p>
                  <p className="w-[20%]">Completed</p>
                </div>

                {chartData.map((data, idx) => {
                  const color = colorCodes[idx % colorCodes.length];
                  return (
                    <div key={idx} className="w-full flex justify-start gap-4 mt-2 text-xs">
                      <div
                        className="w-2 h-2 rounded-full mt-1.5"
                        style={{ backgroundColor: color }}
                      ></div>
                      <p className="w-[35%] font-thin">{capitalizeFirstLetter(data.name)}</p>
                      <p className="w-[15%] font-thin">{data.total_assigned}</p>
                      <p className="w-[15%] font-thin">{data.yet_to_start}</p>
                      <p className="w-[15%] font-thin">{data.pending}</p>
                      <p className="w-[20%] font-thin">{data.completed}</p>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-500">
              No inspection allocation data available
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default InspectionAllocation;